module.exports = __webpack_public_path__ + "static/media/header.1f36fa90.png";